import React from 'react'
import Reseller from '../Reseller'

const ResellerDataDetail = () => {
    return (
        <Reseller>
            
        </Reseller>
    )
}

export default ResellerDataDetail
